module.exports = __webpack_public_path__ + "static/media/image3.ef0a0b48.webp";